<div class="page-bar" *ngIf="isVisible" [class.page-bar--with-title]="pageTitle">
  <button class="page-bar__back" (click)="goBack()" aria-label="Retour à la page précédente">
    <mat-icon>arrow_back</mat-icon>
    <span class="page-bar__back-label" *ngIf="!pageTitle">Retour</span>
  </button>
  <span class="page-bar__title" *ngIf="pageTitle">{{ pageTitle }}</span>
  <span class="page-bar__spacer" *ngIf="pageTitle"></span>
</div>
